module.exports = __webpack_public_path__ + "static/media/wholeSkinStripe.a7e23b96.png";